/* eslint-disable */
import $ from 'jquery';
import 'fancybox';

function init() {
  $('table').wrap('<div class="tableWrap"></div>');
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/article/article.js
 **/